module.exports = __webpack_public_path__ + "static/media/ic_new_logo.acc8c8e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/ic_new_logo.jpg
// module id = 911
// module chunks = 0